import AxiosMockAdapter from 'axios-mock-adapter';

import instance from '@/utils/http';

const mock = [
  { id: '00000000-0000-0000-0000-000000000001', value: 'Цілорічний' },
  { id: '00000000-0000-0000-0000-000000000002', value: 'Опалювальний' },
  { id: '00000000-0000-0000-0000-000000000003', value: 'Міжопалювальний' },
];

const index = new AxiosMockAdapter(instance);

index
  .onGet(/\/api\/season-types\/?(?:\?.*)?$/)
  .reply(200, mock)
  .onAny()
  .passThrough();
